import a from '../img/portImages/1.png';
import b from '../img/portImages/3.png';
import c from '../img/portImages/4.jpg';
import d from '../img/portImages/5.png';
import e from '../img/portImages/6.png';
import f from '../img/portImages/7.png';
import g from '../img/portImages/8.png';
import h from '../img/portImages/9.png';
import i from '../img/portImages/10.png';
import j from '../img/portImages/11.png';
import k from '../img/portImages/12.png';
import l from '../img/portImages/13.png';
import m from '../img/portImages/14.PNG';
import n from '../img/portImages/15.png';
import o from '../img/portImages/16.PNG';
import p from '../img/portImages/17.PNG';
import q from '../img/portImages/18.png';
import r from '../img/portImages/19.png';


const portfolios = [
    {
        id: 9,
        category: 'MERN',
        image: i,
        link1: 'https://github.com/pandeyom331/Daily-Journal',
        link2: 'https://daily-journals-v.herokuapp.com/',
        title: 'Daily-Journal',
        text: 'Daily-Journal Created using Node.js, Express.js, MongoDB, Ejs, BootStrap, HTML, CSS and Deployed on Heroku.'
    },
    {
        id: 17,
        category: 'React Native',
        image: q,
        link1: 'https://github.com/pandeyom331/News-Daily',
        link2: 'https://expo.dev/@pandeyom331/news-daily',
        title: 'News-Daily',
        text: 'News-Daily Created using ReactJS, React-Native, styled-components and deployed on Expo.'
    },
    {
        id: 1,
        category: 'API',
        image: a,
        link1: 'https://github.com/pandeyom331/Weather-App',
        link2: 'https://world-weather-app-v1.herokuapp.com/',
        title: 'Weather-App',
        text: 'Weather-App Created using Ejs, CSS, Node.js, Express.js and deployed on Heroku.'
    },
    {
        id: 6,
        category: 'React JS',
        image: f,
        link1: 'https://github.com/pandeyom331/Emojipedia',
        link2: 'https://pandeyom331.github.io/Emojipedia/',
        title: 'Emojipedia',
        text: 'Emojipedia Created using React.js, CSS and deployed on GitHub.'
    },
    {
        id: 7,
        category: 'React JS',
        image: g,
        link1: 'https://github.com/pandeyom331/Empowerment-Foundation-SparksFoundation-PGI-',
        link2: 'https://pandeyom305.github.io/Empowerment-Foundation-Sparks-PGI/#/',
        title: 'Empowerment-Foundation-SparksFoundation',
        text: 'Empowerment-Foundation Created using React.js and CSS and Deployed on GitHub.'
    },
    {
        id: 8,
        category: 'MERN',
        image: h,
        link1: 'https://github.com/pandeyom331/Horizon-Bank-SparksFoundation-BankingSystem-',
        link2: 'https://horizon-first-bank.herokuapp.com/',
        title: 'Horizon-Bank',
        text: 'Horizon First Bank Created using Node.js, Express.js, MongoDB, Ejs, BootStrap, HTML, CSS and Deployed on Heroku.'
    },
    {
        id: 2,
        category: 'BootStrap,CSS',
        image: b,
        link1: 'https://github.com/pandeyom331/COVID-TRACKER',
        link2: 'https://pandeyom331.github.io/COVID-TRACKER/',
        title: 'COVID-TRACKER',
        text: 'COVID-TRACKER Created using HTML5, CSS3, Bootstrap4 and JavaScript.'
    },
    {
        id: 3,
        category: 'BootStrap',
        image: c,
        link1: 'https://github.com/pandeyom331/Tindog-Tinder-for-Dogs',
        link2: 'https://pandeyom331.github.io/Tindog-Tinder-for-Dogs/',
        title: 'Tindog-Tinder-for-Dogs',
        text: 'Tindog Created using HTML5, CSS3 and Bootstrap4.'
    },
    {
        id: 4,
        category: 'JavaScript',
        image: d,
        link1: 'https://github.com/pandeyom331/Drum-Kit',
        link2: 'https://pandeyom331.github.io/Drum-Kit/',
        title: 'Drum-Kit',
        text: 'Drum-Kit Created using HTML5, CSS3 and JavaScript.'
    },
    {
        id: 5,
        category: 'MERN',
        image: e,
        link1: 'https://github.com/pandeyom331/Todo-list--v1',
        link2: 'https://todo-list--v1.herokuapp.com/',
        title: 'Todo-list',
        text: 'Todo-list--v1 Created using Ejs, CSS, Node.js, Express.js, mongoDB and deployed on Heroku.'
    },
    {
        id: 10,
        category: 'React JS',
        image: j,
        link1: 'https://github.com/pandeyom331/Farmazon-Chat',
        link2: 'https://farmazon-chat.web.app/rooms/YK3FIWF15ZDqXJsp43ED',
        title: 'Farmazon-Chat',
        text: 'Farmazon-Chat Created using React.js, CSS, Firebase and Deployed on Firebase.'
    },
    {
        id: 11,
        category: 'Python',
        image: k,
        link1: 'https://github.com/pandeyom331/Logistic-Regression-Titanic-Machine-Learning-from-Disaster',
        link2: 'https://github.com/pandeyom331/Logistic-Regression-Titanic-Machine-Learning-from-Disaster',
        title: 'Logistic-Regression-Titanic-Machine-Learning-from-Disaster',
        text: 'Logistic regression is a technique in statistical analysis that attempts to predict a data value based on prior observations. A logistic regression algorithm looks at the relationship between a dependent variable and one or more dependent variables.'
    },
    {
        id: 12,
        category: 'Python',
        image: l,
        link1: 'https://github.com/pandeyom331/Linear-Regression-Head-Brain-Model',
        link2: 'https://github.com/pandeyom331/Linear-Regression-Head-Brain-Model',
        title: 'Linear-Regression-Head-Brain-Model',
        text: 'HeadBrain uses machine learning concepts to predict the size of Brain in against of Head weight, we train,test, analyse and predict data from our model which is built upon the concepts of Simple Linear Regression.'
    },
    {
        id: 13,
        category: 'JavaScript',
        image: m,
        link1: 'https://github.com/pandeyom331/Simon-Game',
        link2: 'https://pandeyom331.github.io/Simon-Game/',
        title: 'Simon-Game',
        text: 'Simon-Game Created using HTML5, CSS3, jQuery and JavaScript.'
    },
    {
        id: 14,
        category: 'JavaScript',
        image: n,
        link1: 'https://github.com/pandeyom331/Dice-Game',
        link2: 'https://pandeyom331.github.io/Dice-Game/',
        title: 'Dice-Game',
        text: 'Dice-Game Created using HTML5, CSS3, Bootstrap4 and JavaScript.'
    },
    {
        id: 15,
        category: 'JavaScript',
        image: o,
        link1: 'https://github.com/pandeyom331/Love-Calculator',
        link2: 'https://pandeyom331.github.io/Love-Calculator/#Calculate',
        title: 'Love-Calculator',
        text: 'Love-Calculator Created using HTML5, CSS3, Bootstrap4, JavaScript and jQuery.'
    },
    {
        id: 16,
        category: 'Python',
        image: p,
        link1: 'https://github.com/pandeyom331/Logistic-Regression-SUV-Data-Prediction',
        link2: 'https://github.com/pandeyom331/Logistic-Regression-SUV-Data-Prediction',
        title: 'Logistic-Regression-SUV-Data-Prediction',
        text: 'Logistic regression is a technique in statistical analysis that attempts to predict a data value based on prior observations. A logistic regression algorithm looks at the relationship between a dependent variable and one or more dependent variables.'
    },
    {
        id: 18,
        category: 'React Native',
        image: r,
        link1: 'https://github.com/pandeyom331/Tesla-website-clone-app',
        link2: 'https://expo.dev/@pandeyom331/Tesla',
        title: 'Tesla-app',
        text: 'This repo contains an Telsa Homepage UI Clone App.'
    }
]

export default portfolios;